import { useState } from 'react';
import { UserRole } from '../Enums/UserRole';

export default function useRole() {
    const getRole = () => {
        const roleString = localStorage.getItem('role');
        const userRole = roleString ? JSON.parse(roleString) : UserRole.NotAuthorized;
        return userRole;
    };

    const [role, setRole] = useState(getRole());

    const saveRole = (userRole: string) => {
        localStorage.setItem('role', JSON.stringify(userRole));
        setRole(role);
    };

    return {
        setRole: saveRole,
        role
    }
}